/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Roomannouncementsend2Inputs */

const en_roomannouncementsend2 = /** @type {(inputs: Roomannouncementsend2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Send to everyone inside (${i?.count})`)
};

const de_roomannouncementsend2 = /** @type {(inputs: Roomannouncementsend2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`An alle im Raum senden (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Send to everyone inside ({count})" |
*
* @param {Roomannouncementsend2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const roomannouncementsend2 = /** @type {((inputs: Roomannouncementsend2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roomannouncementsend2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roomannouncementsend2(inputs)
	return de_roomannouncementsend2(inputs)
});
export { roomannouncementsend2 as "roomAnnouncementSend" }